export default {
  periods: [],
  statements : [],
  qpEngineeringUsers : [],
  qpGeologyUsers : [],
  projects : [],
  qps: [],
  professionalOrders: [],
  selectedPeriodId : null,
  variances: []
}
